export default __webpack_public_path__ + "static/media/portfolio.2eba3a65.jpg";